// Country options for Stripe billing address
// Based on ISO 3166-1 alpha-2 codes that Stripe accepts

// Static list of major countries (fallback)
const countryOptions = [
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
  { value: "GB", label: "United Kingdom" },
  { value: "DE", label: "Germany" },
  { value: "FR", label: "France" },
  { value: "VN", label: "Vietnam" },
  { value: "JP", label: "Japan" },
  { value: "AU", label: "Australia" },
  { value: "SG", label: "Singapore" },
  { value: "IN", label: "India" },
  { value: "BR", label: "Brazil" },
  { value: "MX", label: "Mexico" },
  { value: "IT", label: "Italy" },
  { value: "ES", label: "Spain" },
  { value: "NL", label: "Netherlands" },
  { value: "SE", label: "Sweden" },
  { value: "NO", label: "Norway" },
  { value: "DK", label: "Denmark" },
  { value: "FI", label: "Finland" },
  { value: "CH", label: "Switzerland" },
  { value: "AT", label: "Austria" },
  { value: "BE", label: "Belgium" },
  { value: "IE", label: "Ireland" },
  { value: "LU", label: "Luxembourg" },
  { value: "PT", label: "Portugal" },
  { value: "GR", label: "Greece" },
  { value: "PL", label: "Poland" },
  { value: "CZ", label: "Czech Republic" },
  { value: "HU", label: "Hungary" },
  { value: "RO", label: "Romania" },
  { value: "BG", label: "Bulgaria" },
  { value: "HR", label: "Croatia" },
  { value: "SI", label: "Slovenia" },
  { value: "SK", label: "Slovakia" },
  { value: "LT", label: "Lithuania" },
  { value: "LV", label: "Latvia" },
  { value: "EE", label: "Estonia" },
  { value: "MT", label: "Malta" },
  { value: "CY", label: "Cyprus" },
  { value: "KR", label: "South Korea" },
  { value: "CN", label: "China" },
  { value: "TW", label: "Taiwan" },
  { value: "HK", label: "Hong Kong" },
  { value: "TH", label: "Thailand" },
  { value: "MY", label: "Malaysia" },
  { value: "ID", label: "Indonesia" },
  { value: "PH", label: "Philippines" },
  { value: "NZ", label: "New Zealand" },
  { value: "ZA", label: "South Africa" },
  { value: "IL", label: "Israel" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "TR", label: "Turkey" },
  { value: "RU", label: "Russia" },
  { value: "UA", label: "Ukraine" },
  { value: "BY", label: "Belarus" },
  { value: "KZ", label: "Kazakhstan" },
  { value: "UZ", label: "Uzbekistan" },
  { value: "KG", label: "Kyrgyzstan" },
  { value: "TJ", label: "Tajikistan" },
  { value: "TM", label: "Turkmenistan" },
  { value: "AZ", label: "Azerbaijan" },
  { value: "GE", label: "Georgia" },
  { value: "AM", label: "Armenia" },
  { value: "MD", label: "Moldova" },
  { value: "AL", label: "Albania" },
  { value: "MK", label: "North Macedonia" },
  { value: "ME", label: "Montenegro" },
  { value: "RS", label: "Serbia" },
  { value: "BA", label: "Bosnia and Herzegovina" },
  { value: "XK", label: "Kosovo" },
  { value: "IS", label: "Iceland" },
  { value: "FO", label: "Faroe Islands" },
  { value: "GL", label: "Greenland" },
  { value: "AD", label: "Andorra" },
  { value: "MC", label: "Monaco" },
  { value: "LI", label: "Liechtenstein" },
  { value: "SM", label: "San Marino" },
  { value: "VA", label: "Vatican City" },
].sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically by country name

export default countryOptions;
